export default __webpack_public_path__ + "static/media/cblogo.4f559999.png";